import { render, staticRenderFns } from "./CopyTextElement.vue?vue&type=template&id=37af6bc2&scoped=true"
import script from "./CopyTextElement.vue?vue&type=script&lang=js"
export * from "./CopyTextElement.vue?vue&type=script&lang=js"
import style0 from "./CopyTextElement.vue?vue&type=style&index=0&id=37af6bc2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af6bc2",
  null
  
)

export default component.exports